// polyfills
import "core-js/es6/map";
import "core-js/es6/set";
import "core-js/es6/symbol";
import * as Intl from "intl";
import "intl/locale-data/jsonp/en";
import "whatwg-fetch";

(window as any).Intl = Intl;

// other stuff
import "react-select/dist/react-select.css";
import * as _ from "lodash";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { FpProvider, ActivityIndicator } from "./common/index";
import * as Common from "./common";
import { FpId, LIB_INSTANCES } from "./lib/index"; //, MediaApiDropHandler

import "@fortawesome/fontawesome";
import "@fortawesome/fontawesome-pro-brands";
import "@fortawesome/fontawesome-pro-light";
import "@fortawesome/fontawesome-pro-regular";
import "@fortawesome/fontawesome-pro-solid";

// fleetplan wants a older underscore version
_.noConflict();

interface IRenderOptions {
	el: string | Element;
	module: string;
	view: string;
	props?: any;
}

// tslint:disable-next-line:no-string-literal
export const FP_WEB = window["FP_WEB"] = {
	FpId: FpId,
	LIB_INSTANCES: LIB_INSTANCES,

	render: async function(options: IRenderOptions) {
		const domEl = typeof options.el === "string"
			? document.querySelector(options.el)
			: options.el;

		if (domEl == null) {
			// TODO: use log
			console.error("FP_WEB: el not found", options);
			throw new Error(`FP_WEB: el not found: ${options.el}`);
		}

		let otherModule;
		if (options.module === "common") {
			otherModule = Common;
		} else {
			// show a spinner while we lazy load the missing script
			ReactDOM.render(<ActivityIndicator size="lg"/>, domEl);
			otherModule = await import(`./modules/${options.module}/index`);
		}

		// tslint:disable-next-line:variable-name
		const ViewClass = otherModule[options.view];

		let reactEl = <FpProvider>
			<ViewClass {...options.props}/>
		</FpProvider>;

		ReactDOM.render(reactEl, domEl);
	},
};

//new MediaApiDropHandler();



// WEBPACK FOOTER //
// ./src/main.tsx